// Vorschläge unter der leeren Eingabe (ki-assistent §8.3, §10): NUR Daten für die Oberfläche. Sie kommen aus einer
// gepflegten Tabelle, gefiltert nach den Rechten des Nutzers – nie aus einem Modellaufruf, und nichts wird
// ausgeführt: Ein Tipp auf einen Vorschlag füllt die Eingabe; alles Weitere läuft den gewöhnlichen Weg mit Vorschau.
import { z } from 'zod'
import { defineContract } from '@shared/contract'

export const suggestionList = defineContract({
  name: 'assistant.suggestion.list',
  title: 'Vorschläge für den Assistenten anzeigen',
  description: 'Drei bis vier Beispielanfragen, passend zu Rechten und Seite.',
  llm: {
    description: 'Liefert Beispielanfragen für die leere Eingabe des Assistenten. Nur für die Oberfläche.',
    keywords: [],
  },
  input: z.strictObject({
    /** Pfad der Seite, auf der der Nutzer steht, z. B. '/items' */
    route: z.string().max(200).optional(),
  }),
  output: z.object({
    suggestions: z.array(
      z.object({
        id: z.string(),
        /** Text für die Eingabe; „…“ markiert die Stelle, die der Nutzer ergänzt */
        text: z.string(),
        /** question: Auskunft · change: bereitet eine Änderung vor (mit Vorschau und Bestätigung) */
        kind: z.enum(['question', 'change']),
      }),
    ),
  }),
  permission: 'assistant.chat.use',
  risk: 'read',
  assistant: 'never',
})
